import React from 'react';
import { UIText1 } from '@cian/ui-kit';

import { SidebarTip } from './SidebarTip';
import { TriangleExclamation } from '../Images';
import * as s from './SidebarTips.css';

/**
 * Карточка "Запреты публикации" в сайдбаре
 */
export const SidebarPostPublicationProhibitions = () => {
  const items = [
    'Реклама услуг или себя',
    'Нецензурная лексика',
    'Оскорбления, агрессия',
    'Призыв к насилию или дискриминации',
    'Личные данные клиентов',
    'Политическая агитация',
  ];

  return (
    <SidebarTip title="Что запрещено" image={<TriangleExclamation />} theme={'var(--theme-gray)'}>
      <ul className={s['items-wrapper']}>
        {items.map((item, index) => (
          <li key={index}>
            <UIText1>{item}</UIText1>
          </li>
        ))}
      </ul>
    </SidebarTip>
  );
};
